module.exports = __webpack_public_path__ + "static/media/location-arrow-solid.3cbe8edf.svg";